import { withRouter } from 'react-router-dom'
import QueryStringMonitor from './QueryStringMonitor'

export default withRouter(QueryStringMonitor)
